import { useQuery } from "react-query";
import { buildEnrichmentOptions } from "@/v2/entities/enrichment/Enrichment.model";
import { useEnrichmentApi } from "@/v2/entities/enrichment/Enrichment.api";
import { ExploreEnrichment } from "@/v2/entities/explore/Explore.model";

export function useExploreEnrichments(): ExploreEnrichment[] {
  const enrichmentApi = useEnrichmentApi();

  const { data } = useQuery({
    queryKey: ["enrichments"],
    queryFn: () => enrichmentApi.getAll(),
    select: (data) =>
      data
        .filter(
          (enrichment) =>
            enrichment.isEnabled &&
            (enrichment.copilotBlocks == null ||
              enrichment.copilotBlocks.length === 0)
        )
        .map((enrichment) => ({
          id: enrichment.id,
          value: enrichment.name.replace(/\s+/g, "_").toLowerCase(),
          label: enrichment.name,
          options: buildEnrichmentOptions(enrichment.options),
        })),
    enabled: true,
  });

  return data ?? [];
}
